import styled from 'styled-components';
import Media from '../../utils/media';

/* -------------------------- MAIN FUNCTION --------------------------- */
export const MainFunctionStyled = styled.div`
  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    max-width: ${Media.SIZE.MD}px;
    height: max-content;
    padding: 10px 15px;
  }
`;

export const MainTitleStyled = styled.div`
  font-family: SVN-GilroyMedium;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  padding-top: 70px;

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    font-size: 30px;
    font-weight: 700;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    /* font-style: italic;
    text-decoration: underline; */
  }
`;

export const MainWrapCardStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0px auto;
  width: calc(100% - 190px);
  padding-top: 65px;
  gap: 0 70px;

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.XS';

    gap: 0 40px;
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    display: flex;
    flex-wrap: wrap;
    margin: 0px auto;
    width: 100%;
    padding-top: 15px;
    gap: unset;
  }
`;

export const MainItemCardStyled = styled.div`
  width: calc((100% - 70px) / 2);
  height: auto;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0px 4px 15px 2px #0000001f;
  transition: box-shadow 0.3s ease;
  padding: 30px;

  .image {
    img {
      width: fit-content;
    }
  }

  &:hover {
    box-shadow: 0px 4px 15px 2px #0000004d;
  }

  &:nth-child(n + 3) {
    margin-top: 25px;
  }

  .text-1 {
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    padding-top: 28px;
  }

  .text-2 {
    font-family: SVN-GilroyLight;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    padding-top: 10px;
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.MD';
    min-height: max-content;
    height: unset;

    &:nth-child(n + 3) {
      margin-top: 20px;
    }

    .text-1 {
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      padding-top: 28px;
    }
    .text-2 {
      font-family: SVN-GilroyLight;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      padding-top: 10px;
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    width: 100%;
    height: max-content;
    border-radius: 15px;
    text-align: center;
    box-shadow: 0px 4px 15px 2px #0000001f;
    transition: box-shadow 0.3s ease;
    padding: 10px;

    &:hover {
      box-shadow: 0px 4px 15px 2px #0000004d;
    }

    &:nth-child(n + 3) {
      margin-top: unset;
    }

    &:not(:first-child) {
      margin-top: 10px;
    }

    .image {
      margin: 0px auto;
      width: 50%;

      img {
        /* max-width: 300px; */
        object-fit: cover;
        width: 100%;
      }
    }

    .text-1 {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      padding-top: 10px;
    }

    .text-2 {
      font-family: SVN-GilroyLight;
      font-size: 13px;
      font-weight: 400;
      text-align: center;
      padding: 10px 20px;
    }
  }
`;

export const DownloadStyled = styled.div`
  width: calc(100% - 240px * 2);
  display: flex;
  margin: 125px auto 0;
  justify-content: space-between;

  .left {
    .download {
      font-family: SVN-GilroyMedium;
      font-size: 32px;
      font-weight: 700;
      text-align: left;
    }

    .description-download {
      font-family: SVN-GilroyLight;
      font-size: 16px;
      font-weight: 400;
      text-align: left;

      margin-top: 30px;
    }

    .list {
      padding-left: 24px;
      margin-top: 30px;

      .item-list {
        display: flex;
        align-items: center;

        &:not(:first-child) {
          margin-top: 16px;
        }

        .item-list-text {
          font-family: SVN-GilroyLight;
          font-size: 16px;
          font-weight: 400;
          text-align: left;
          margin-left: 8px;
        }
      }
    }
  }

  .right {
    .btn {
      width: max-content;
      cursor: pointer;

      &:last-child {
        margin-top: 35px;
      }
    }
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.XL';

    width: calc(100% - 180px * 2);
    flex-direction: column;
    margin-top: 55px;

    .left {
      display: flex;
      flex-direction: column;
      width: max-content;
      margin: 0px auto;

      .download {
        font-family: SVN-GilroyMedium;
        font-size: 24px;
        font-weight: 700;
        text-align: left;
      }

      .description-download {
        font-family: SVN-GilroyLight;
        font-size: 14px;
        font-weight: 400;
        text-align: left;

        margin-top: 15px;
      }

      .list {
        padding-left: 10px;
        margin-top: 20px;

        .item-list {
          display: flex;
          align-items: center;

          &:not(:first-child) {
            margin-top: 5px;
          }

          .item-list-text {
            font-family: SVN-GilroyLight;
            font-size: 13px;
            font-weight: 400;
            text-align: left;
            margin-left: 8px;
          }
        }
      }
    }

    .right {
      margin-top: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .btn {
        width: max-content;
        cursor: pointer;

        &:last-child {
          margin-top: 5px;
        }
      }
    }
  }

  ${Media.lessThan(Media.SIZE.LG)} {
    display: none;
  }
`;
